import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4cdf695b&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=4cdf695b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf695b",
  null
  
)

export default component.exports